import React, { Fragment } from 'react';
import cn from 'classnames';

import Button from 'ui/Button';

import { ON_COLOR_SETTINGS } from 'constants/settings';

import { isDarkAppearance, isLightAppearance } from '../utils';

const PREVIEW_BUTTON_LABELS = {
  [ON_COLOR_SETTINGS.AUTO]: t('settings.tab.customization.preview.auto'),
  [ON_COLOR_SETTINGS.DARK]: t('settings.tab.customization.preview.dark'),
  [ON_COLOR_SETTINGS.LIGHT]: t('settings.tab.customization.preview.light'),
};

const OnColorButtons = ({
  ariaBase = 'company-setting-on-color-button',
  ariaLabels = {},
  buttonClassName,
  color,
  complentaryColor,
  onColorChange,
}) => (
  <>
    {Object.values(ON_COLOR_SETTINGS).map(setting => (
      <Fragment key={setting}>
        <div className="mr-32">
          <Button
            id={`${ariaBase}_${setting}`}
            aria-label={ariaLabels[setting]}
            className={cn(buttonClassName, 'mb-8', {
              'SettingsContent-radioButton--dark': isDarkAppearance(
                setting,
                complentaryColor,
              ),
              'SettingsContent-radioButton--light': isLightAppearance(
                setting,
                complentaryColor,
              ),
            })}
            onClick={() => onColorChange(setting)}
            alt={setting}
            value={setting}
          >
            {t('settings.tab.customization.preview.title')}
          </Button>
          <label htmlFor={`${ariaBase}_${setting}`} className="c-p d-f">
            <span
              className={cn('ta-c w-half bdrs-4 m-a', {
                'SettingsContent-radio--selected border': setting === color,
              })}
            >
              {PREVIEW_BUTTON_LABELS[setting]}
            </span>
          </label>
        </div>
      </Fragment>
    ))}
  </>
);

export default OnColorButtons;
